export default __webpack_public_path__ + "static/media/2B.d3b99dfc.svg";